import React from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import moment from 'moment'
import _ from 'lodash'

const fuelType = {
  gas: 'Gasolina',
  premiumGas: 'Gasolina Aditivada',
  ethanol: 'Etanol',
  diesel: 'Diesel'
}

const styles = {
  tableRowColumn: {
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  }
}

const Monetary = (props) => (
  <TableRowColumn>
    R$ 
    {
      isNaN(props.value) 
      ? '0,00'
      : (props.value).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 3})
    }
  </TableRowColumn>
)

const DateField = (props) => (
  <TableRowColumn style={styles.tableRowColumn}>
    {
      props.value
      ? moment(props.value).format('DD/MM/YYYY HH:mm')
      : '01/01/2000'
    }
  </TableRowColumn>
)

const Odometer = (props) => (
  <TableRowColumn>
    {
      isNaN(props.value)
      ? '-'
      : `${(props.value).toLocaleString('de-DE')} km`
    }
  </TableRowColumn>
)

const FuelField = (props) => {
  return (
    <TableRowColumn>
      {_.get(fuelType, props.value, props.value)}
    </TableRowColumn>
  )
}

const matchRows = (data, index, props) => (
  <TableRow key={index} selectable={false}>
    <TableRowColumn>{data._id.slice(-6)}</TableRowColumn>
    <DateField value={data.createdAt} />
    <TableRowColumn style={styles.tableRowColumn}>{data._user.firstName}</TableRowColumn>
    <TableRowColumn style={styles.tableRowColumn}>{data._gasStation.name}</TableRowColumn>
    <Odometer value={data.odometer} />
    <FuelField value={data.fuelType} />
    <Monetary value={data.fuelCost} />
    <Monetary value={data.value} />
    {
      !props.hideEfficiency &&
      <TableRowColumn>{`${data.efficiency} km/l`}</TableRowColumn>
    }
  </TableRow>
)

const TransactionHistory = (props) => (
  <Table>
    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
      <TableRow>
        <TableHeaderColumn>ID</TableHeaderColumn>
        <TableHeaderColumn>DATA</TableHeaderColumn>
        <TableHeaderColumn>USUÁRIO</TableHeaderColumn>
        <TableHeaderColumn>POSTO</TableHeaderColumn>
        <TableHeaderColumn>ODÔMETRO</TableHeaderColumn>
        <TableHeaderColumn>COMBUSTÍVEL</TableHeaderColumn>
        <TableHeaderColumn>PREÇO</TableHeaderColumn>
        <TableHeaderColumn>TOTAL</TableHeaderColumn>
        {
          !props.hideEfficiency &&
          <TableHeaderColumn>EFICIÊNCIA</TableHeaderColumn>
        }
      </TableRow>
    </TableHeader>
    <TableBody displayRowCheckbox={false}>
      {
        props.data &&
        props.data.map((item, index) => matchRows(item, index, props))
      }
    </TableBody>
  </Table>
)

export default TransactionHistory



// WEBPACK FOOTER //
// ./src/components/transactionHistory.js